export interface ModHash {
  items: string[];
  beacons: string[];
  belts: string[];
  fuels: string[];
  wagons: string[];
  machines: string[];
  modules: string[];
  recipes: string[];
  technologies: string[];
}
